import {Component, computed, input} from '@angular/core';
import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';

@Component({
  selector: 'app-importance-icon',
  templateUrl: './importance-icon.component.html',
})
export class ImportanceIconComponent {
  readonly importanceScore = input<EvaluationSubCriteriaImportanceScore | null | undefined>();
  private readonly defaultSizeClass = 'text-4xl';
  private readonly notRelevantSizeClass = 'text-2xl';

  protected readonly iconClass = computed(() => {
    const icon = this.getIconForImportanceScore(this.importanceScore());
    if (!icon) {
      return '';
    }

    const sizeClass =
      this.importanceScore() === EvaluationSubCriteriaImportanceScore.NOT_RELEVANT
        ? this.notRelevantSizeClass
        : this.defaultSizeClass;

    return `${icon} ${sizeClass}`;
  });

  private getIconForImportanceScore(
    importanceScore: EvaluationSubCriteriaImportanceScore | null | undefined,
  ): string {
    switch (importanceScore) {
      case EvaluationSubCriteriaImportanceScore.BASIC_ATTRIBUTE:
        return 'ph-bold ph-cell-signal-high';
      case EvaluationSubCriteriaImportanceScore.PERFORMANCE_ATTRIBUTE:
        return 'ph-bold ph-cell-signal-medium';
      case EvaluationSubCriteriaImportanceScore.ENTHUSIASM_ATTRIBUTE:
        return 'ph-bold ph-cell-signal-low';
      case EvaluationSubCriteriaImportanceScore.INDIFFERENT_ATTRIBUTE:
        return 'ph-bold ph-cell-signal-none';
      case EvaluationSubCriteriaImportanceScore.NOT_RELEVANT:
        return 'ph ph-x-circle';
      default:
        return '';
    }
  }
}
